import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { MtAccount } from "server/models"
import { deepCopy, StateType } from "client/utils"
import {
    StoreType,
    UserProps,
    AccountList,
    AccountFilters,

    ChangeAccountStatus,
    SortAccounts,
    AddAccountUser,
    LoadAccountPackages,

    closeModal,
    setAccountList,
    setNotAssignedUserAccountIds,
    setNotAssignedUserAccountSort,
    setNotAssignedUserAccountFilters,
    setNotAssignedUserAccountSelected,
    setUserAccountReloadList,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    PageForm,
    Button,
    TableSearchWrapper,
    Table,
    SortRows,
    ChangeStatus,
    SpinnerIcon,
} from "client/components"

import AccountSearch from "client/pages/search/accountSearch"
import Columns from "./columns"

let isMounted: boolean

const NotAssignedAccounts = ({
    userId = null,
}: UserProps) => {
    const packageList = useSelector((state: StoreType) => state.package.packageList)
    const accountList = useSelector((state: StoreType) => state.account.accountList)
    const userAccountList = useSelector((state: StoreType) => state.accountUser.userAccountList)

    const accountIds = useSelector((state: StoreType) => state.accountUser.notAssignedAccounts.accountIds)
    const sortColumn = useSelector((state: StoreType) => state.accountUser.notAssignedAccounts.sortColumn)
    const sortOrder = useSelector((state: StoreType) => state.accountUser.notAssignedAccounts.sortOrder)
    const filters = useSelector((state: StoreType) => state.accountUser.notAssignedAccounts.filters)
    const selected = useSelector((state: StoreType) => state.accountUser.notAssignedAccounts.selected)

    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [saveState, setSaveState] = useState<StateType>(IDLE)

    useEffect(() => {
        isMounted = true
        return () => {
            isMounted = false
        }
    }, [])

    useEffect(() => {
        const sortedAccountIds = SortAccounts(Object.values(accountList), sortColumn, sortOrder, filters)
        const userAccountIds = userAccountList && userAccountList[userId] ? userAccountList[userId] : []

        const sortedNotAssigned = sortedAccountIds.filter((accountId) => !userAccountIds.includes(accountId))
        dispatch(setNotAssignedUserAccountIds(sortedNotAssigned))
    }, [userAccountList, sortColumn, sortOrder, filters])

    const onSort: SortRows = (column: keyof MtAccount, order) => {
        dispatch(setNotAssignedUserAccountSort(column, order))
    }

    const onFilter = (newFilters: AccountFilters) => {
        dispatch(setNotAssignedUserAccountFilters(newFilters))
        dispatch(setNotAssignedUserAccountSelected(null))
    }

    const onStatusChange: ChangeStatus = (account: MtAccount, callback) => {
        ChangeAccountStatus(account).then((status) => {
            callback(() => {
                const accountListCopy: AccountList = deepCopy(accountList)
                accountListCopy[account.id] = {
                    ...accountListCopy[account.id],
                    status,
                }
                dispatch(setAccountList(accountListCopy))
            })
        })
    }

    const addUserAccount = () => {
        const accountId = selected && selected.length ? selected[0] : null
        if (!accountId) return

        setSaveState(PENDING)
        LoadAccountPackages(accountId).then((accountPackages) => {
            const packageId = accountPackages.length ? accountPackages[0].packageId : null
            const activePackage = packageList ? packageList[packageId] : null
            const maxUsers = activePackage ? activePackage.maxUsers : null

            AddAccountUser([userId], accountId, maxUsers).then(() => {
                if (isMounted) {
                    setSaveState(IDLE)
                    dispatch(closeModal())
                }
                dispatch(setNotAssignedUserAccountSelected(null))

                dispatch(setUserAccountReloadList(false))
                setTimeout(() => {
                    dispatch(setUserAccountReloadList(true))
                }, 0)
            })
        })
    }

    const columns = Columns()

    return (
        <Container>
            <PageHeader>
                <PageTitle>{lang.selectAccount}</PageTitle>
            </PageHeader>
            <PageContent>
                <TableSearchWrapper>
                    <AccountSearch
                        id="notAssignedUserAccounts"
                        filters={filters}
                        onFilter={onFilter}
                    />
                </TableSearchWrapper>
                <Table
                    columns={columns}
                    dataList={accountList}
                    dataIds={accountIds}
                    selectedIds={selected}
                    sortColumn={sortColumn}
                    sortOrder={sortOrder}
                    rowSize="md"
                    showPagination
                    onSort={onSort}
                    onStatusChange={onStatusChange}
                />
                <PageForm>
                    <Button variant="success" onClick={addUserAccount}>
                        {saveState === PENDING ? <SpinnerIcon /> : lang.select}
                    </Button>
                </PageForm>
            </PageContent>
        </Container>
    )
}
export default NotAssignedAccounts
